import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import uuid from 'uuid-random';

const MAX_FILES = 50;
const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const MIN_FILE_SIZE = 10 * 1024; // 10KB
const MIN_FILE_WIDTH = 500;
const MIN_FILE_HEIGHT = 500;
const MAX_FILE_WIDTH = 6000;
const MAX_FILE_HEIGHT = 6000;
const FILE_LIMIT_ERROR = 'too-many-files';
const FILE_SIZE_ERROR = 'file-too-large';

const isTouchDevice = () => {
  return 'ontouchstart' in window;
};

const backendForDND = isTouchDevice() ? TouchBackend : HTML5Backend;

const createPicture = (file, multimediaType) => ({
  file,
  angle: 0,
  multimediaType,
  id: uuid(),
  error: file.error
});

export {
  backendForDND,
  MAX_FILE_HEIGHT,
  MAX_FILE_WIDTH,
  MIN_FILE_HEIGHT,
  MIN_FILE_WIDTH,
  MAX_FILES,
  MAX_FILE_SIZE,
  MIN_FILE_SIZE,
  FILE_LIMIT_ERROR,
  FILE_SIZE_ERROR,
  createPicture
};
